import * as React from 'react';
import { makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles({
  root: {
    width: '275px',
    height: '290px',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: 28,
    backgroundColor: 'lightgrey',
    textAlign: 'center',
  },
});

const FirebaseLink = (props) => {
  const classes = useStyles();
  const { salesCenter } = props;

  function handleNav() {
    window.open(`https://console.firebase.google.com/u/0/project/${salesCenter.subdomain}/overview`, '_blank');
  }

  return (
    <div>
      <Card className={classes.root} variant="outlined">
        <CardContent>
          <Typography className={classes.title} color="textSecondary" gutterBottom>
            Firebase DB Link
          </Typography>
          <br /><br /><br /><br /><br />
        </CardContent>
        <CardActions style={{ justifyContent: 'center', marginTop: 'auto' }}>
          <Button
            variant="contained"
            size="small"
            color="primary"
            // eslint-disable-next-line react/jsx-no-bind
            onClick={handleNav}
          >Nav to Firebase
          </Button>
        </CardActions>
      </Card>

    </div>
  );
};

export default FirebaseLink;
